export enum ViewType {
    view = 'LeaderBoard',
    cashBack = 'Cashback',
}
